export default __webpack_public_path__ + "static/media/cancel.30f874ce.svg";